import { ArpMediaType } from '@arpeggi/shared'
import { Icons } from '@arpeggi/ui'
import { FC } from 'react'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useVerifyMedia } from '../../verified-media'
import { useHashTabs } from '../hooks'
import { Navbar } from '../primitives'
import { ArpActionsSection } from './ArpActionsSection'
import { ArpDetailsTabContent } from './ArpDetailsTabContent'
import { ArpDNATabContent } from './ArpDNATabContent'
import { ArpRemixesTabContent } from './ArpRemixesTabContent'
import { ArpVerifiedTabContent } from './ArpVerifiedTabContent'
import { Tab } from './Tab'

export const ArpSecondarySection: FC<{ media: IArpMedia }> = ({ media }) => {
  const { verifiedIDs } = useVerifyMedia({ arpMediaId: media.id })
  const isSample = media.type === ArpMediaType.SAMPLE
  const title = media.type === ArpMediaType.SONG ? 'Song DNA' : 'Sound DNA'
  const defaultTab = isSample ? '#remixes' : '#dna'
  const showVerfied = verifiedIDs?.length > 0
  const { currentTab, setTab } = useHashTabs(defaultTab)
  return (
    <Tabs.Root value={currentTab} onValueChange={setTab}>
      <Navbar.Root>
        <Navbar.Content>
          <Navbar.TabArea>
            <Tabs.List>
              {!isSample && <Tab value="#dna" label={title} icon={<Icons.DNA />} />}
              <Tab value="#remixes" label="Remixes" icon={<Icons.Remix />} />
              {showVerfied && <Tab value="#verified" label="Verified" icon={<Icons.Verified />} />}
              <Tab value="#details" label="Details" icon={<Icons.Details />} />
            </Tabs.List>
          </Navbar.TabArea>
          <Navbar.Actions>
            <ArpActionsSection media={media} />
          </Navbar.Actions>
        </Navbar.Content>
      </Navbar.Root>
      {!isSample && <ArpDNATabContent media={media} />}
      <ArpRemixesTabContent media={media} />
      {showVerfied && <ArpVerifiedTabContent media={media} />}
      <ArpDetailsTabContent media={media} />
    </Tabs.Root>
  )
}
